import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { subscribeElectronNavigate } from "@/lib/electron";

/**
 * Empfängt SPA-Navigation aus dem Electron-Main-Prozess (zweites Fenster).
 */
export function useElectronNavigateBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    return subscribeElectronNavigate((path) => {
      const normalized = String(path || "").trim();
      if (!normalized.startsWith("/")) return;
      navigate(normalized);
    });
  }, [navigate]);
}
